import {
    FETCH_HEARTED_PICS_SUCCESS,
    FETCH_HEARTED_PICS_ERROR,
    HEART_PIC_SUCCESS,
    UNHEART_PIC_SUCCESS
} from '../actions/engageActions';

export function heartsReducer(state, action) {
    switch (action.type) {
        case FETCH_HEARTED_PICS_SUCCESS: {
            return Object.assign({}, state, {
                heartedPics: action.payload
            });
        }

        case FETCH_HEARTED_PICS_ERROR: {
            return state;
        }

        case HEART_PIC_SUCCESS: {
            return Object.assign({}, state, {
                heartedPics: Object.assign({}, state.heartedPics, {
                    [action.payload.id]: action.payload.id
                })
            });
        }

        case UNHEART_PIC_SUCCESS: {
            const currentCore = Object.assign({}, state);
            delete currentCore.heartedPics[action.payload.id];
            return currentCore;
        }

        default:
            return state;
    }
}
